<template>
  <div style="height:100%;">
    <div class="fl iconfont icon-backwards" :class="{'touched':touchedClass}" @click.prevent="goback()" ref="backbtn" v-if="!urlCode"><span @click.prevent="goback()" class="headText">返回</span></div>
    <div class="fr iconfont icon-gesture" v-if="hasGesture"><span class="headText">向左滑动</span></div>
    <div class="title">{{pageTitle}}</div>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import utils from '../../utils';
  import enums from '@/enums/index.js'
  export default {
    data(){
      let isMobile = false;
      let isAndroid = false;
      let isIos = false;
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        isMobile = true;
        isIos = true;
      } else if (/(Android)/i.test(navigator.userAgent)) {
        isMobile = true;
        isAndroid = true;
      }
      return {
        isMobile, isAndroid, isIos, isPc: !isMobile,
        urlCode: utils.getSearch().code,
        isBackBtnTouched: false,
        touchedClass: false,
        isBacking: false,
        utTimeout: null,
      }
    },
    computed: mapState([
      'pageTitle',
      'hasGesture'
    ]),
    methods: {
      goback(){
        if (!this.isBacking) {
          this.isBacking = true;
          setTimeout(() => {
            this.isBacking = false;
          }, 500);
          setTimeout(() => {
            this.$router.go(-1);
          }, 100);
        }
      },
      bindTouch(){
        this.$refs.backbtn.addEventListener(enums.Events.touchStart, this.touchTrigger);
        document.body.addEventListener(enums.Events.touchEnd, this.unTouchTrigger);
        document.body.addEventListener('touchcancel', this.unTouchTrigger);
      },
      unbindTouch(){
        this.$refs.backbtn.removeEventListener(enums.Events.touchStart, this.touchTrigger);
        document.body.removeEventListener(enums.Events.touchEnd, this.unTouchTrigger);
        document.body.removeEventListener('touchcancel', this.unTouchTrigger);
      },
      touchTrigger(e){
        e.preventDefault();
        this.isBackBtnTouched = true;
        this.touchedClass = true;
        const isWindowsAio = !!document.querySelector('.windows-aio');
        if (this.isMobile || isWindowsAio) {
          this.goback();//
        }
      },
      unTouchTrigger(){
        clearTimeout(this.utTimeout);
        this.utTimeout = setTimeout(() => {
          setTimeout(() => {
            this.isBackBtnTouched = false;
          }, 200);
          this.touchedClass = false;
          //this.goback();
        }, 100);
      }
    },
    mounted(){
      if (this.$refs.backbtn) {
        this.bindTouch();
      }
    },
    beforeDestroy(){
      if (this.$refs.backbtn) {
        this.unbindTouch();
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/less/base.less';

  .iconfont {
    font-size: 48px;
    color: @color-white;
  }

  .icon-backwards {
    &.touched {
      opacity: 0.5;
    }
  }

  .icon-gesture:before {
    display: inline-block;
    transform: rotate(0deg);
    animation: shaking 2s infinite;
  }

  @keyframes shaking {
    0% {
      transform: rotate(-20deg)
    }
    50% {
      transform: rotate(20deg)
    }
    100% {
      transform: rotate(-20deg)
    }
  }

  .headText {
    display: inline-block;
    margin-left: 0.8em;
    font-size: @font-size-normal;
    vertical-align: middle;
    letter-spacing: 0.5em;
  }

  .title {
    margin: 0 212px;
    font-weight: bold;
    font-size: @font-size-normal*2;
    color: @color-white;
    letter-spacing: 0.2em;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// head.vue?1186d0fe